import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "invoice" }
const _hoisted_4 = { class: "col-sm-12 text-center mt-3" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexInvoice',
  setup(__props) {

const Card8 = defineAsyncComponent(() => import("@/components/commen/card/cardData8.vue"))
const invoiceHeader = defineAsyncComponent(() => import("@/components/theme/ecommerce/invoice/invoiceHeader.vue"))
const invoiceProfile = defineAsyncComponent(() => import("@/components/theme/ecommerce/invoice/invoiceProfile.vue"))
const invoiceTable = defineAsyncComponent(() => import("@/components/theme/ecommerce/invoice/invoiceTable.vue"))
function printWindow() {
    window.print();
}

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "ECommerce",
      title: "Invoice"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card8), { colClass: "col-sm-12" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createVNode(_unref(invoiceHeader)),
                _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1)),
                _createVNode(_unref(invoiceProfile)),
                _createVNode(_unref(invoiceTable))
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "btn btn btn-primary me-2",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (printWindow()))
                }, "Print"),
                _cache[2] || (_cache[2] = _createElementVNode("button", {
                  class: "btn btn-secondary",
                  type: "button"
                }, "Cancel", -1))
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})